import { useContext, useMemo } from "react";
import { MAIN, TOURNAMENT_TYPE_BY_ID } from "../../constants/TournamentTypeConstants";
import WBCYearsContext from "../../contexts/WBCYearsContext";

/**
 * Custom hook to get the current tournament type from the selected WBC year settings
 * This is the standard way to determine tournament type throughout the application.
 * @returns {{tournamentType: string|null, isMainTournament: boolean, tournamentTypeId: number|null}} Object containing the tournament type, a boolean flag, and the tournament ID
 */
const useTournamentType = () => {
  const { selectedWbcYear } = useContext(WBCYearsContext);

  return useMemo(() => {
    let tournamentType = null;
    let tournamentTypeId = null;
    if (
      selectedWbcYear &&
      selectedWbcYear.generalRosterSettings &&
      selectedWbcYear.generalRosterSettings.tournamentTypeId
    ) {
      tournamentTypeId = selectedWbcYear.generalRosterSettings.tournamentTypeId;
      tournamentType = TOURNAMENT_TYPE_BY_ID[tournamentTypeId];
    }

    return {
      tournamentType,
      isMainTournament: tournamentType === MAIN,
      tournamentTypeId
    };
  }, [selectedWbcYear]);
};

export default useTournamentType;
